export const visit = (vm, at) => {
at({ "en": { "publicPricingPage": { "errorFallback": { "title": "All is not lost.", "paragraph": "But something's not right. Please refresh your page and try again." } } } });
};